(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-deletion"] && !Shopify.designMode) return;
  try {
    
// You can add any necessary JavaScript here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__rspInit) return;
  window.__rspInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HLS_OK = (function () {
    var v = document.createElement('video');
    return !!v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl') !== '';
  })();
  var SLIDE_MS = 4000;

  function Spot(root) {
    var self = this;
    this.root = root;
    this.track = root.querySelector('.rsp__track');
    var items = [].slice.call(this.track.querySelectorAll('.rsp__item'));
    this.n = items.length;
    if (!this.n) return;
    /* The loop repeats short lists so both sides of the widest screen are filled,
       with one hidden card at the seam where cards wrap around. */
    var need = 2 * Math.ceil(Math.max(window.screen.width || 0, window.innerWidth) / 2 / 262) + 2;
    var copies = this.n > 1 ? Math.ceil(need / this.n) : 1;
    for (var c = 1; c < copies; c++) {
      items.forEach(function (it) {
        var cl = it.cloneNode(true);
        cl.classList.remove('is-active');
        self.track.appendChild(cl);
      });
    }
    this.slots = [].slice.call(this.track.querySelectorAll('.rsp__item'));
    this.m = this.slots.length;
    this.a = 0;
    this.slide = 0;
    this.paused = reduce;
    this.soundOn = false;
    this.inView = false;
    this.video = null;
    this.timer = null;
    this.dir = getComputedStyle(root).direction === 'rtl' ? -1 : 1;
    root.style.setProperty('--rsp-dir', this.dir);
    this.layout(0);
    this.syncCtrls();

    root.addEventListener('click', this.onClick.bind(this));
    root.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('rsp__media')) {
        e.preventDefault();
        self.onMedia(e.target.closest('.rsp__item'), null);
      }
    });
    var tx = null, ty = null;
    root.addEventListener('touchstart', function (e) {
      /* a drag inside the product list scrolls the list, it is not a swipe */
      tx = e.target.closest('.rsp__shop') ? null : e.touches[0].clientX;
      ty = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      tx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        self.paused = false;
        self.step((dx < 0 ? 1 : -1) * self.dir);
      }
    }, { passive: true });

    new IntersectionObserver(function (en) {
      self.inView = en[0].isIntersecting;
      if (self.inView) self.play(); else self.stop();
    }, { threshold: 0.35 }).observe(root);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stop(); else self.play();
    });
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { self.layout(0); }, 150);
    });
  }

  Spot.prototype.cur = function () { return this.slots[this.a]; };
  Spot.prototype.images = function (s) {
    if (!s._imgs) s._imgs = JSON.parse(s.getAttribute('data-images') || '[]');
    return s._imgs;
  };

  /* moved: how many places the active card advanced, so cards that wrap around
     (their offset jumps the other way) move without animating. */
  Spot.prototype.layout = function (moved) {
    var m = this.m, half = Math.floor(m / 2), a = this.a;
    var cs = getComputedStyle(this.root);
    var w = parseFloat(cs.getPropertyValue('--rsp-w')) || 250;
    var gap = parseFloat(cs.getPropertyValue('--rsp-gap')) || 12;
    var reach = Math.ceil((this.root.clientWidth / 2 - w / 2) / (w + gap));
    this.slots.forEach(function (s, j) {
      var o = ((((j - a + half) % m) + m) % m) - half;
      s.classList.toggle('no-anim', s._o === undefined || o !== s._o - moved);
      s._o = o;
      s.style.setProperty('--o', o);
      s.classList.toggle('is-active', o === 0);
      var far = Math.abs(o) > reach;
      s.classList.toggle('is-far', far);
      if (far) s.setAttribute('inert', ''); else s.removeAttribute('inert');
    });
  };

  Spot.prototype.go = function (j) {
    if (j === this.a || this.m < 2) return;
    var m = this.m, d = (((j - this.a) % m) + m) % m;
    if (d > m / 2) d -= m;
    this.stop();
    this.closeLists();
    if (this.video && this.video.parentNode) this.video.parentNode.removeChild(this.video);
    this.a = j;
    this.slide = 0;
    this.layout(d);
    this.play();
  };
  Spot.prototype.step = function (d) {
    this.go((((this.a + d) % this.m) + this.m) % this.m);
  };

  Spot.prototype.play = function () {
    this.stop();
    if (!this.inView || document.hidden) return;
    var s = this.cur(), open = s.classList.contains('is-open');
    if (s.hasAttribute('data-images')) {
      this.showSlide(this.slide);
      if (!this.paused && !open) this.timer = setTimeout(this.autoSlide.bind(this), SLIDE_MS);
    } else if (!this.paused && !open) {
      this.playVideo(s);
    }
  };
  Spot.prototype.stop = function () {
    clearTimeout(this.timer);
    this.timer = null;
    if (this.video) this.video.pause();
  };
  Spot.prototype.autoSlide = function () {
    if (this.slide + 1 < this.images(this.cur()).length) {
      this.showSlide(this.slide + 1);
      this.timer = setTimeout(this.autoSlide.bind(this), SLIDE_MS);
    } else {
      this.step(1);
    }
  };

  /* Photo post: build the slides on first use; load the shown photo and the next one. */
  Spot.prototype.showSlide = function (n) {
    var s = this.cur(), urls = this.images(s), media = s.querySelector('.rsp__media');
    if (!urls.length) return;
    var box = media.querySelector('.rsp__slides');
    if (!box) {
      box = document.createElement('span');
      box.className = 'rsp__slides';
      urls.forEach(function (u) {
        var im = document.createElement('img');
        im.className = 'rsp__slide';
        im.alt = '';
        im.setAttribute('data-src', u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=720');
        box.appendChild(im);
      });
      media.insertBefore(box, media.querySelector('.rsp__dots') || media.querySelector('.rsp__ctrls'));
    }
    var ims = box.children, len = ims.length;
    n = ((n % len) + len) % len;
    this.slide = n;
    [n, (n + 1) % len].forEach(function (k) {
      var im = ims[k];
      if (im.hasAttribute('data-src')) {
        im.setAttribute('src', im.getAttribute('data-src'));
        im.removeAttribute('data-src');
      }
    });
    for (var k = 0; k < len; k++) ims[k].classList.toggle('is-on', k === n);
    var dots = media.querySelectorAll('.rsp__dot');
    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === n);
  };

  /* Reel: one shared <video>, moved into the centre card. Muted autoplay; the lighter
     720p file is plenty for a 300px card (HLS on Safari). At the end, move on. */
  Spot.prototype.playVideo = function (s) {
    var src = (HLS_OK && s.getAttribute('data-video-hls')) || s.getAttribute('data-video-mobile') || s.getAttribute('data-video');
    if (!src) return;
    var self = this, v = this.video;
    if (!v) {
      v = this.video = document.createElement('video');
      v.className = 'rsp__video';
      v.muted = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('disablepictureinpicture', '');
      v.preload = 'auto';
      v.addEventListener('playing', function () { v.classList.add('is-on'); });
      v.addEventListener('ended', function () { if (!self.paused) self.step(1); });
    }
    var media = s.querySelector('.rsp__media');
    if (v.parentNode !== media) {
      v.classList.remove('is-on');
      media.insertBefore(v, media.querySelector('.rsp__ctrls'));
      if (v.getAttribute('src') === src) v.currentTime = 0;
    }
    if (v.getAttribute('src') !== src) {
      v.classList.remove('is-on');
      v.setAttribute('src', src);
    }
    v.muted = !this.soundOn;
    var p = v.play();
    if (p && p.catch) p.catch(function (e) {
      /* sound blocked without a fresh tap: carry on muted */
      if (e && e.name === 'NotAllowedError' && !v.muted) {
        self.soundOn = false;
        v.muted = true;
        self.syncCtrls();
        v.play().catch(function () {});
      }
    });
  };

  Spot.prototype.onClick = function (e) {
    var t = e.target, b = t.closest('[data-rsp-add]');
    if (b) { e.preventDefault(); addToCart(b); return; }
    b = t.closest('[data-rsp-step]');
    if (b) { this.paused = false; this.syncCtrls(); this.step(+b.getAttribute('data-rsp-step')); return; }
    var s = t.closest('.rsp__item');
    if (!s) return;
    if (t.closest('[data-rsp-more]')) { this.toggleList(s); return; }
    if (t.closest('[data-rsp-pause]')) { this.paused = !this.paused; this.syncCtrls(); this.play(); return; }
    if (t.closest('[data-rsp-sound]')) { this.toggleSound(); return; }
    if (t.closest('.rsp__media')) this.onMedia(s, e);
  };

  /* Side card: bring it to the centre. Centre post: next photo (left 30% = back).
     Centre reel: sound on/off (or resume when paused). */
  Spot.prototype.onMedia = function (s, e) {
    var j = this.slots.indexOf(s);
    if (j !== this.a) { this.paused = false; this.syncCtrls(); this.go(j); return; }
    if (s.hasAttribute('data-images')) {
      var back = false;
      if (e && e.clientX) {
        var r = s.querySelector('.rsp__media').getBoundingClientRect();
        back = this.dir > 0 ? e.clientX - r.left < r.width * 0.3 : r.right - e.clientX < r.width * 0.3;
      }
      this.showSlide(this.slide + (back ? -1 : 1));
      this.play();
    } else if (this.paused) {
      this.paused = false;
      this.syncCtrls();
      this.play();
    } else {
      this.toggleSound();
    }
  };

  Spot.prototype.toggleSound = function () {
    this.soundOn = !this.soundOn;
    if (this.video) this.video.muted = !this.soundOn;
    this.syncCtrls();
  };
  Spot.prototype.syncCtrls = function () {
    var self = this, L = this.root.dataset;
    [].forEach.call(this.root.querySelectorAll('[data-rsp-sound]'), function (b) {
      b.setAttribute('aria-pressed', self.soundOn ? 'true' : 'false');
      b.setAttribute('aria-label', self.soundOn ? L.lMute : L.lUnmute);
    });
    [].forEach.call(this.root.querySelectorAll('[data-rsp-pause]'), function (b) {
      b.setAttribute('aria-pressed', self.paused ? 'true' : 'false');
      b.setAttribute('aria-label', self.paused ? L.lPlay : L.lPause);
    });
  };

  Spot.prototype.toggleList = function (s) {
    var open = !s.classList.contains('is-open');
    this.closeLists();
    s.classList.toggle('is-open', open);
    var b = s.querySelector('[data-rsp-more]');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (s === this.cur()) this.play();
  };
  Spot.prototype.closeLists = function () {
    this.slots.forEach(function (x) {
      if (!x.classList.contains('is-open')) return;
      x.classList.remove('is-open');
      var b = x.querySelector('[data-rsp-more]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  };

  /* Same request and drawer refresh as assets/product-form.js. */
  function addToCart(btn) {
    if (btn.classList.contains('is-loading')) return;
    var routes = (window.theme && window.theme.routes) || {};
    var cart = document.querySelector('mini-cart');
    var id = btn.getAttribute('data-rsp-add');
    var shop = btn.closest('.rsp__shop');
    var old = shop && shop.querySelector('.rsp__err');
    if (old) old.remove();
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
      fd.append('sections_url', window.location.pathname);
      cart.setActiveElement(btn);
    }
    btn.classList.add('is-loading');
    fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (shop) {
            var p = document.createElement('p');
            p.className = 'rsp__err';
            p.setAttribute('role', 'alert');
            p.textContent = res.description || res.message || '';
            shop.appendChild(p);
            setTimeout(function () { p.remove(); }, 5000);
          }
          return;
        }
        if (!cart || !cart.renderContents) { window.location = routes.cart_url || '/cart'; return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'reels-spotlight', productVariantId: id, cart: res });
        }
        cart.renderContents(res);
      })
      .catch(function (e) { console.error(e); })
      .then(function () { btn.classList.remove('is-loading'); });
  }

  function initAll(scope) {
    [].forEach.call(scope.querySelectorAll('[data-rsp]'), function (r) {
      if (!r._rsp) r._rsp = new Spot(r);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__srlInit) return;
  window.__srlInit = true;

  /* ---------- Strip: lazy animated thumbnails ---------- */
  var playerOpen = false;
  var reduceMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function playThumb(v) {
    if (reduceMotion || playerOpen) return;
    if (!v.src && v.dataset.src) v.src = v.dataset.src;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function eachThumb(fn) {
    Array.prototype.forEach.call(document.querySelectorAll('.srl__thumbvid'), fn);
  }
  function pauseStrip() { eachThumb(function (v) { if (v.src) v.pause(); }); }
  function resumeStrip() {
    eachThumb(function (v) {
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) playThumb(v);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) playThumb(v);
      else if (v.src) v.pause();
    });
  }, { rootMargin: '200px' });
  function observeThumbs(root) {
    root.querySelectorAll('.srl__thumbvid').forEach(function (v) {
      if (!v.dataset.srlBound) {
        v.dataset.srlBound = '1';
        v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      }
      io.observe(v);
    });
  }
  observeThumbs(document);
  /* Theme editor re-renders sections with fresh DOM — re-bind. */
  document.addEventListener('shopify:section:load', function (e) { observeThumbs(e.target); });

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-srl-scroll]');
    if (nav) {
      var track = nav.closest('.srl__wrap').querySelector('.srl__track');
      var rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollBy({ left: track.clientWidth * 0.8 * (+nav.dataset.srlScroll) * rtl, behavior: 'smooth' });
      return;
    }
    var card = e.target.closest('.srl__card');
    if (card && !card.classList.contains('srl__card--empty')) {
      e.preventDefault();
      openPlayer(card.closest('.srl__item'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('srl__card')
        && !e.target.classList.contains('srl__card--empty')) {
      e.preventDefault();
      openPlayer(e.target.closest('.srl__item'));
    }
  });

  /* ---------- Player ---------- */
  var modal = null, video = null, reels = [], idx = 0, slide = 0;
  var profile = { pic: '', name: '' }, errText = 'Could not load this video';
  var errImg = 'Could not load this post';
  var soundOn = true;                    /* persists across reels (H1) */
  var L = { player: 'Video player', close: 'Close', mute: 'Mute',
            unmute: 'Unmute', prev: 'Previous', next: 'Next',
            imgPrev: 'Previous photo', imgNext: 'Next photo' };
  var opener = null, scrollY = 0, triedFallback = false;

  function canHls() {
    var v = document.createElement('video');
    return !!v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl') !== '';
  }
  var HLS_OK = canHls();
  function netTier() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
    if (c.saveData) return 'save';
    var e = c.effectiveType || '';
    if (e === 'slow-2g' || e === '2g') return 'slow';
    if (e === '3g') return 'mid';
    return 'fast';
  }
  function pickSrc(r) {
    /* Safari/iOS: HLS is adaptive, so it already climbs to the best rendition. */
    if (r.hls && HLS_OK) return r.hls;
    var t = netTier();
    if (t === 'save' || t === 'slow') return r.mobile || r.video || r.hd || '';
    if (t === 'mid') return r.video || r.mobile || r.hd || '';
    /* good connection: the original upload out-resolves every Shopify rendition */
    return r.hd || r.video || r.mobile || '';
  }
  function nextSrcDown(r, current) {
    var chain = [r.hd, r.video, r.mobile].filter(Boolean);
    for (var i = 0; i < chain.length; i++) {
      if (chain[i] !== current) return chain[i];
    }
    return '';
  }
  function bigPoster(u) { return u ? u.replace('width=480', 'width=1080') : u; }
  function imgW(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function collect(section) {
    var wantProfile = section.dataset.showProfile === '1';
    profile.pic = wantProfile ? (section.dataset.profilePic || '') : '';
    profile.name = wantProfile ? (section.dataset.profileName || '') : '';
    L.player = section.dataset.lblPlayer || L.player;
    L.close  = section.dataset.lblClose  || L.close;
    L.mute   = section.dataset.lblMute   || L.mute;
    L.unmute = section.dataset.lblUnmute || L.unmute;
    L.prev   = section.dataset.lblPrev   || L.prev;
    L.next   = section.dataset.lblNext   || L.next;
    L.imgPrev = section.dataset.lblImgPrev || L.imgPrev;
    L.imgNext = section.dataset.lblImgNext || L.imgNext;
    errText = section.dataset.errText || errText;
    errImg = section.dataset.errImg || errImg;
    /* every rendered card (reel or photo post) carries data-index */
    return Array.prototype.map.call(section.querySelectorAll('.srl__item[data-index]'), function (it) {
      var imgs = null;
      if (it.dataset.images) {
        try { imgs = JSON.parse(it.dataset.images); } catch (e) { imgs = null; }
      }
      return {
        video: it.dataset.video || '',
        hd: it.dataset.videoHd || '',
        mobile: it.dataset.videoMobile || '',
        hls: it.dataset.videoHls || '',
        images: (imgs && imgs.length) ? imgs : null,
        poster: it.dataset.poster || '',
        tpl: it.querySelector('.srl__products')
      };
    });
  }

  function build() {
    modal = document.createElement('div');
    modal.className = 'srl-modal';
    var dlg = document.createElement('div');
    dlg.className = 'srl-stage';
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-label', L.player);
    modal.appendChild(dlg);

    /* explicit arrows: the peek slivers collapse on many desktop sizes (M2) */
    var chev = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
    var bPrev = document.createElement('button');
    bPrev.className = 'srl-pnav srl-pnav--prev';
    bPrev.setAttribute('data-srl-prev', ''); bPrev.setAttribute('aria-label', L.prev);
    bPrev.innerHTML = chev;
    var bNext = document.createElement('button');
    bNext.className = 'srl-pnav srl-pnav--next';
    bNext.setAttribute('data-srl-next', ''); bNext.setAttribute('aria-label', L.next);
    bNext.innerHTML = chev.replace('M15 18l-6-6 6-6', 'M9 6l6 6-6 6');
    modal.appendChild(bPrev); modal.appendChild(bNext);
    document.body.appendChild(modal);

    video = document.createElement('video');
    video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
    video.loop = true; video.preload = 'metadata';
    video.disablePictureInPicture = true;

    video.addEventListener('waiting', function () { var c = cur(); if (c) c.classList.add('is-loading'); });
    video.addEventListener('playing', function () {
      var c = cur();
      if (c) { c.classList.remove('is-loading'); c.classList.remove('is-error'); }
    });
    video.addEventListener('error', function () {
      var r = reels[idx];
      if (!r || r.images) return;
      /* one retry on the base rendition before giving up */
      var fb = nextSrcDown(r, video.src);
      if (!triedFallback && fb && video.src !== fb) {
        triedFallback = true;
        video.src = fb;
        var p = video.play(); if (p && p.catch) p.catch(function () {});
        return;
      }
      showError();
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-srl-close]')) { close(); return; }
      if (e.target.closest('[data-srl-sound]')) { toggleSound(); return; }
      var sb = e.target.closest('[data-srl-slide]');
      if (sb) { stepSlide(+sb.getAttribute('data-srl-slide')); return; }
      if (e.target.closest('[data-srl-prev]')) { step(-1); return; }
      if (e.target.closest('[data-srl-next]')) { step(1); return; }
      if (e.target.closest('.srl-reel.is-before')) step(-1);
      else if (e.target.closest('.srl-reel.is-after')) step(1);
      else if (!e.target.closest('.srl-reel')) close();
    });

    var ty = null, tx = null, tIgnore = false;
    modal.addEventListener('touchstart', function (e) {
      ty = e.touches[0].clientY; tx = e.touches[0].clientX;
      /* don't hijack a drag that starts on the shoppable product carousel */
      tIgnore = !!(e.target.closest && e.target.closest('.srl-products'));
    }, { passive: true });
    modal.addEventListener('touchend', function (e) {
      if (ty === null) return;
      var dy = e.changedTouches[0].clientY - ty;
      var dx = e.changedTouches[0].clientX - tx;
      var ignore = tIgnore;
      ty = tx = null; tIgnore = false;
      if (ignore) return;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {   /* horizontal: photo carousel */
        stepSlide(dx < 0 ? 1 : -1);
        return;
      }
      if (Math.abs(dy) < 50) return;
      if (Math.abs(dx) > Math.abs(dy)) return;   /* horizontal swipe: not a reel change */
      if (dy < 0) step(1); else step(-1);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      /* left/right walk a post's photos first, then carry on to the next reel */
      if (e.key === 'ArrowRight') { if (!stepSlide(1)) step(1); return; }
      if (e.key === 'ArrowLeft') { if (!stepSlide(-1)) step(-1); return; }
      if (e.key === 'ArrowDown') { step(1); return; }
      if (e.key === 'ArrowUp') { step(-1); return; }
      if (e.key === 'Tab') {
        var f = modal.querySelectorAll('button, a[href]');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function cur() { return modal && modal.querySelector('.srl-reel.is-current'); }

  function showError() {
    var c = cur();
    if (!c) return;
    c.classList.remove('is-loading');
    c.classList.add('is-error');
  }

  function slideBtn(d) {
    var b = document.createElement('button');
    b.className = 'srl-snav srl-snav--' + (d < 0 ? 'prev' : 'next');
    b.setAttribute('data-srl-slide', String(d));
    b.setAttribute('aria-label', d < 0 ? L.imgPrev : L.imgNext);
    b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="' +
      (d < 0 ? 'M15 18l-6-6 6-6' : 'M9 6l6 6-6 6') + '"/></svg>';
    return b;
  }

  function reelEl(i, pos) {
    var r = reels[i];
    var el = document.createElement('div');
    el.className = 'srl-reel ' + pos;

    if (r.images) {
      /* photo post: blurred fill behind the photo, which is always shown whole.
         r.poster is the card-sized first photo, already cached by the strip. */
      var bl = document.createElement('img');
      bl.className = 'srl-reel__blur';
      bl.alt = '';
      bl.setAttribute('src', r.poster);
      el.appendChild(bl);
      if (pos !== 'is-current') {
        var peek = document.createElement('img');
        peek.className = 'srl-slide is-on';
        peek.alt = '';
        peek.setAttribute('src', r.poster);
        el.appendChild(peek);
      }
    } else if (r.poster) {
      var post = document.createElement('img');
      post.className = 'srl-reel__poster';
      post.alt = '';
      post.setAttribute('src', pos === 'is-current' ? bigPoster(r.poster) : r.poster);
      el.appendChild(post);
    }
    var loader = document.createElement('span');
    loader.className = 'srl-loader';
    el.appendChild(loader);

    if (pos === 'is-current') {
      var err = document.createElement('div');
      err.className = 'srl-error';
      err.textContent = r.images ? errImg : errText;
      el.appendChild(err);

      if (r.images) {
        /* src stays in data-src until showSlide() needs the photo */
        r.images.forEach(function (u) {
          var im = document.createElement('img');
          im.className = 'srl-slide';
          im.alt = '';
          im.setAttribute('data-src', imgW(u, 1080));
          im.addEventListener('load', function () {
            if (im.classList.contains('is-on')) el.classList.remove('is-loading');
          });
          im.addEventListener('error', function () {
            if (im.classList.contains('is-on')) {
              el.classList.remove('is-loading');
              el.classList.add('is-error');
            }
          });
          el.appendChild(im);
        });
        if (r.images.length > 1) {
          el.appendChild(slideBtn(-1));
          el.appendChild(slideBtn(1));
        }
      }

      var head = document.createElement('div');
      head.className = 'srl-reel__head';
      var prof = document.createElement('span');
      prof.className = 'srl-reel__profile';
      if (profile.pic) {
        var av = document.createElement('img');
        av.className = 'srl-reel__avatar';
        av.alt = '';
        av.setAttribute('src', profile.pic);
        prof.appendChild(av);
      }
      var nm = document.createElement('p');
      nm.className = 'srl-reel__name';
      nm.textContent = profile.name;
      prof.appendChild(nm);
      head.appendChild(prof);
      var cl = document.createElement('button');
      cl.className = 'srl-reel__close';
      cl.setAttribute('data-srl-close', '');
      cl.setAttribute('aria-label', L.close);
      cl.innerHTML = '<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      head.appendChild(cl);
      el.appendChild(head);

      var foot = document.createElement('div');
      foot.className = 'srl-reel__foot';
      if (r.images) {
        /* photos have no sound; multi-photo posts get position dots instead */
        foot.innerHTML = (r.images.length > 1
            ? '<div class="srl-dots" aria-hidden="true">' +
              new Array(r.images.length + 1).join('<span class="srl-dot"></span>') + '</div>'
            : '') +
          '<div class="srl-products"></div>';
      } else {
        foot.innerHTML = '<button class="srl-reel__sound" data-srl-sound aria-label="Mute">&#128266;</button>' +
          '<div class="srl-products"></div>';
      }
      var wrap = foot.querySelector('.srl-products');
      if (r.tpl && r.tpl.content) {
        var frag = r.tpl.content.cloneNode(true);
        frag.querySelectorAll('img[data-src]').forEach(function (im) {
          var u = im.getAttribute('data-src');
          im.removeAttribute('data-src');
          if (u) im.setAttribute('src', u);
          else im.remove();
        });
        wrap.appendChild(frag);
      }
      el.appendChild(foot);
    }
    return el;
  }

  /* Photo posts: show photo n. Only it and its neighbours are fetched. */
  function showSlide(n) {
    var c = cur(), r = reels[idx];
    if (!c || !r || !r.images) return;
    var ims = c.querySelectorAll('.srl-slide');
    if (n < 0 || n >= ims.length) return;
    slide = n;
    for (var k = n - 1; k <= n + 1; k++) {
      var im = ims[k];
      if (im && im.hasAttribute('data-src')) {
        im.setAttribute('src', im.getAttribute('data-src'));
        im.removeAttribute('data-src');
      }
    }
    for (var a = 0; a < ims.length; a++) ims[a].classList.toggle('is-on', a === n);
    c.classList.remove('is-error');
    if (ims[n].complete) {
      c.classList.remove('is-loading');
      if (!ims[n].naturalWidth) c.classList.add('is-error');
    } else {
      c.classList.add('is-loading');
    }
    var dots = c.querySelectorAll('.srl-dot');
    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === n);
    var sp = c.querySelector('[data-srl-slide="-1"]'), sn = c.querySelector('[data-srl-slide="1"]');
    if (sp) sp.disabled = (n <= 0);
    if (sn) sn.disabled = (n >= ims.length - 1);
  }
  /* false when there is no photo that way, so callers can move to the next reel */
  function stepSlide(dir) {
    var r = reels[idx];
    if (!r || !r.images) return false;
    var n = slide + dir;
    if (n < 0 || n >= r.images.length) return false;
    showSlide(n);
    return true;
  }

  function render() {
    triedFallback = false;
    slide = 0;
    var stage = modal.querySelector('.srl-stage');
    stage.innerHTML = '';
    if (idx > 0) stage.appendChild(reelEl(idx - 1, 'is-before'));
    var c = reelEl(idx, 'is-current');
    stage.appendChild(c);
    if (idx < reels.length - 1) stage.appendChild(reelEl(idx + 1, 'is-after'));

    var src = pickSrc(reels[idx]);
    video.pause();
    video.removeAttribute('src');
    video.load();
    if (reels[idx].images) { showSlide(0); syncNav(); focusClose(); return; }
    if (!src) { showError(); focusClose(); return; }

    c.classList.add('is-loading');
    video.src = src;
    video.muted = !soundOn;
    c.insertBefore(video, c.querySelector('.srl-reel__head'));
    var p = video.play();
    if (p && p.catch) p.catch(function (e) {
      if (e && e.name === 'NotAllowedError') {
        soundOn = false; video.muted = true;
        var p2 = video.play(); if (p2 && p2.catch) p2.catch(function () {});
        updateSound();
      }
    });
    updateSound();
    syncNav();
    focusClose();
  }

  function focusClose() {
    var b = modal.querySelector('[data-srl-close]');
    if (b) b.focus();
  }

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function openPlayer(item) {
    if (!modal) build();
    opener = document.activeElement;
    var section = item.closest('.srl');
    reels = collect(section);
    idx = +item.dataset.index || 0;
    if (idx >= reels.length) idx = 0;
    modal.classList.add('is-open');
    playerOpen = true;
    pauseStrip();
    lockScroll();
    render();
  }

  function step(dir) {
    var n = idx + dir;
    if (n < 0 || n >= reels.length) return;
    idx = n;
    render();
  }

  function close() {
    video.pause();
    video.removeAttribute('src');
    video.load();
    modal.classList.remove('is-open');
    playerOpen = false;
    resumeStrip();
    unlockScroll();
    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  function toggleSound() { soundOn = !soundOn; video.muted = !soundOn; updateSound(); }
  function updateSound() {
    var b = modal.querySelector('[data-srl-sound]');
    if (!b) return;
    b.innerHTML = video.muted ? '&#128263;' : '&#128266;';
    b.setAttribute('aria-label', video.muted ? L.unmute : L.mute);
  }
  function syncNav() {
    var p = modal.querySelector('[data-srl-prev]'), n = modal.querySelector('[data-srl-next]');
    if (p) p.disabled = (idx <= 0);
    if (n) n.disabled = (idx >= reels.length - 1);
  }

  /* Theme editor niceties */
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var item = (t.matches && t.matches('.srl__item[data-video]'))
      ? t
      : (t.querySelector && t.querySelector('.srl__item[data-video]'));
    if (item) openPlayer(item);
  });
  document.addEventListener('shopify:block:deselect', function () { if (modal) close(); });
})();

  } catch(e) { console.error(e); }
})();
})();
